import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateSystemSettingsRequest,
  UpdateField,
  FetchSystemSettingsRequest,
} from './system-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getSystemSettingsState } from './system-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'
import { FetchDataCyclesRequest } from '@containers/data-cycles/data-cycles.actions'
import { FetchRoundFactorsRequest } from '@shared/shared.actions'
import { getRoundFactorsState } from '@shared/shared.select'
import { getDataCyclesState } from '@containers/data-cycles/data-cycles.selectors'

@Component({
  selector: 'app-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.css'],
})
export class SystemSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  public dataCycles: []
  public roundFactors: []
  private dataCyclesState$: Subscription
  private roundFactorsState$: Subscription
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getSystemSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.dataCyclesState$ = this.store
      .pipe(select(getDataCyclesState))
      .subscribe((state) => {
        this.dataCycles = state.get('data').toJS()
      })

    this.roundFactorsState$ = this.store
      .pipe(select(getRoundFactorsState))
      .subscribe((state) => {
        this.roundFactors = state
      })

    this.store.dispatch<any>(new FetchRoundFactorsRequest())
    this.store.dispatch<any>(
      new FetchDataCyclesRequest({
        pageSize: 100,
      }),
    )
    this.store.dispatch(new FetchSystemSettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
    this.dataCyclesState$.unsubscribe()
    this.roundFactorsState$.unsubscribe()
  }

  public getZeros(number: number) {
    return '0'.repeat(number)
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SYSTEM_ACTIVE_DATA_CYCLE: 'required',
      SYSTEM_ROUND_FACTOR: 'required',
      SYSTEM_BUSINESS_ID_PREFIX: 'required',
      SYSTEM_BUSINESS_ID_NUMERIC_LENGTH: 'required',
      SYSTEM_BUILDING_ID_PREFIX: 'required',
      SYSTEM_BUILDING_ID_NUMERIC_LENGTH: 'required',
      SYSTEM_PROPERTY_CODE_SERIAL_LENGTH: 'required',
      SYSTEM_PROPERTY_CODE_PREFIX: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SYSTEM_BUSINESS_ID_PREFIX: 'business id prefix',
      SYSTEM_ACTIVE_DATA_CYCLE: 'current data cycle',
      SYSTEM_BUILDING_ID_PREFIX: 'building id prefix',
      SYSTEM_ROUND_FACTOR: 'round factor',
      SYSTEM_PROPERTY_CODE_SERIAL_LENGTH: 'property code serial length',
      SYSTEM_BUILDING_ID_NUMERIC_LENGTH: 'building id numeric length',
      SYSTEM_PROPERTY_CODE_PREFIX: 'property code prefix',
      SYSTEM_BUSINESS_ID_NUMERIC_LENGTH: 'business id numeric length',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const {
      SYSTEM_PROPERTY_CODE_SERIAL_LENGTH,
      SYSTEM_BUILDING_ID_NUMERIC_LENGTH,
      SYSTEM_BUSINESS_ID_NUMERIC_LENGTH,
      SYSTEM_COMPOUND_ID_NUMERIC_LENGTH,
      SYSTEM_ACTIVE_DATA_CYCLE,
      SYSTEM_ROUND_FACTOR,
      ...payload
    } = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(
        new UpdateSystemSettingsRequest({
          SYSTEM_PROPERTY_CODE_SERIAL_LENGTH: parseInt(
            SYSTEM_PROPERTY_CODE_SERIAL_LENGTH,
            10,
          ),
          SYSTEM_BUILDING_ID_NUMERIC_LENGTH: parseInt(
            SYSTEM_BUILDING_ID_NUMERIC_LENGTH,
            10,
          ),
          SYSTEM_BUSINESS_ID_NUMERIC_LENGTH: parseInt(
            SYSTEM_BUSINESS_ID_NUMERIC_LENGTH,
            10,
          ),
          SYSTEM_COMPOUND_ID_NUMERIC_LENGTH: parseInt(
            SYSTEM_COMPOUND_ID_NUMERIC_LENGTH,
            10,
          ),
          SYSTEM_ACTIVE_DATA_CYCLE: parseInt(SYSTEM_ACTIVE_DATA_CYCLE, 10),
          SYSTEM_ROUND_FACTOR: parseFloat(SYSTEM_ROUND_FACTOR),
          ...payload,
        }),
      )
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
